import {
  Filter,
  FilterMatchingType,
} from "interfaces/filters";

export const filtersDefs: Array<Filter> = [
  {
    name: 'name',
    label: 'Metric Name',
    matching: FilterMatchingType.STRING_INCLUDES,
    value: '',
  },
  {
    name: 'origin',
    label: 'Metric Origin',
    matching: FilterMatchingType.ARRAY_INCLUDES_PROPERTY,
    options: 'metricOriginOptions',
    optionNameField: 'name',
    optionValueField: 'value',
    value: [],
  },
  {
    name: 'type.name',
    path: ['type', 'name'],
    label: 'Metric Type',
    matching: FilterMatchingType.STRING_INCLUDES,
    value: '',
  },
  {
    name: 'aggregationMethod',
    label: 'Aggregation Method',
    matching: FilterMatchingType.ARRAY_INCLUDES_PROPERTY,
    options: 'aggregationMethodOptions',
    optionNameField: 'name',
    optionValueField: 'value',
    value: [],
  },
];
